import Axios from 'axios';
import React, { useEffect, useState } from 'react'
import NotData from '../../components/NotData';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { elapsedTime } from '../../common/howDate';

const ItemManagement = () => {

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss');

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }

  const [books, setBooks] = useState([]);
  const columns = [
    'No', '상태', '제품 이름', '매장', '아이디', '처리 시간'
  ];
  
  const [date, setDate] = useState(()=>{
    return toDay.date;
  });

  const [itemState, setItemState] = useState('');
  const [itemStore, setItemStore] = useState('');
  const [itemBrand, setItemBrand] = useState('');
  const [itemBrand2, setItemBrand2] = useState('');
  const [itemType, setItemType] = useState('');
  const [itemType2, setItemType2] = useState('');
  const [itemName, setItemName] = useState('');
  const [itemName2, setItemName2] = useState('');
  const [itemPrice, setItemPrice] = useState(0);
  const [itemPrice2, setItemPrice2] = useState(0);
  const [itemCount, setItemCount] = useState(0);
  const [itemCount2, setItemCount2] = useState(0);
  const [itemUser, setItemUser] = useState('');
  const [itemDate, setItemDate] = useState('');
  
  // 숫자 천자리 콤마
  function NumberConvert(num)
  {
    var num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num_parts.join(".");
  }

  // 처음 로딩시 불러오는 부분
  useEffect(()=>{
    document.title = '재고 수정 내역';

    DataLoad();
  }, [date])

  // 날짜 변경시
  const ChangedDate = async (e)=>{
    await Axios.get(`/api/itemmanagement/itemlog`, {
      params: { Date: e.target.value }
    })
    .then((res)=>{
      if (res.data.length) {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    })
    .catch((err)=>{
      console.log('Error: ', err);
    })
  };

  // 리스트 불러오기
  const DataLoad = async ()=>{
    if(!date) setDate(toDay.date);

    await Axios.get(`/api/itemmanagement/itemlog`, {
      params: { Date: date }
    })
    .then((res)=>{
      if (res.data.length) {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    })
    .catch((err)=>{
      console.log('Error: ', err);
    })
  }

  // 셀렉트 테스트
  const [selectedRow, setSelectedRow] = useState(-1);

  const navigate = useNavigate();
  
  return (    

    <div className='p-3 flex flex-col gap-3 whitespace-nowrap'>
    <div className='flex justify-between items-center'>
      <ul className='flex gap-3'>
        <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto`} onClick={(e)=>navigate('/itemmanagement/itemlist')}>재고 목록</li>
        <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto border-[1px] border-yellow-500 rounded-md`} onClick={(e)=>navigate('/itemmanagement/itemlog')}>재고 수정 내역</li>
      </ul>
      {/* <div>
        <button className='px-5 py-3 text-yellow-400'>새로고침</button>
      </div> */}
    </div>
    
    <div className='grid grid-cols-1 md:flex md:justify-between text-sm md:h-[calc(100vh-8.9rem)] gap-1'>

    {/* 메인 */}
    <div className='relative border-[1px] border-gray-500 w-full md:w-3/4 md:h-full h-[60vh] overflow-y-auto'>
      <table id='testTable' className='w-full'>
        <thead className='bg-[#1E1E1E]/90 whitespace-nowrap text-center sticky top-0 z-10'>
          <tr className='border-b-[1px] border-gray-500'>
            {columns.map((column) => (
              <th className='p-3' key={column}>{column}</th>
            ))}
          </tr>
        </thead>
        <tbody className='text-center'>
          {
            books.length ?
            books.map((book, idx) => (
              <tr className=
              {`
                duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80
                ${selectedRow === idx ? 'bg-[#1E1E1E] font-bold underline decoration-[3px]' : 'even:bg-[#3E3E3E]'}
              `}
              key={idx} onClick={(e)=>{
                setSelectedRow(idx);
                setItemState(book.log);
                setItemStore(book.store);
                setItemBrand(book.i_brand);
                setItemBrand2(book.brand);
                setItemType(book.i_type);
                setItemType2(book.type);
                setItemName(book.i_name);
                setItemName2(book.name);
                setItemPrice(book.i_price);
                setItemPrice2(book.price);
                setItemCount(book.i_count);
                setItemCount2(book.count);
                setItemUser(book.userid);
                setItemDate(book.date);

                window.sessionStorage.setItem('select_copy', book.i_name);
              }}>
                <td className='p-2.5'>{idx + 1}</td>
                <td className='p-2.5 border-x-[1px] border-gray-500'>
                  <p className={`rounded-sm px-2 py-1
                    ${book.log === '추가' && 'bg-blue-500/80'}
                    ${book.log === '수정' && 'bg-green-600/80'}
                    ${book.log === '삭제' && 'bg-red-500/80'}
                  `}>
                    {book.log}
                  </p>
                </td>
                <td className='p-2.5 border-x-[1px] border-gray-500'>{book.i_name}</td>
                <td className='p-2.5 border-x-[1px] border-gray-500'>{book.store}</td>
                <td className='p-2.5 border-x-[1px] border-gray-500'>{book.userid}</td>
                <td className={`p-2.5 ${elapsedTime(book.date) === '방금 전' && 'animate-pulse'}`}>{elapsedTime(book.date)}</td>
              </tr>
            ))
            :
            <tr className='relative'>
              <td className='absolute w-full top-[30vh] left-auto'>
                <NotData/>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    {/* 사이드 */}
    <div className='md:w-1/4 w-full md:overflow-y-auto bg-[#424242] border-[1px] border-gray-500'>
      <div className='bg-[#0067BD] py-2 text-center'>
        <div className='text-left pl-3'>
          <span>※ 전체 매장 변경 로그</span>
        </div>
      </div>

      {/* 날짜 조회 */}
      <div className='flex flex-col p-3 mb-[-12px] gap-2'>
        <div className='w-full'>
          <p>수정된 날짜 조회</p>
          <input type='date' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md cursor-pointer outline-none border-[1px] border-gray-400' value={date} onChange={(e)=>{
            setDate(e.target.value);
            ChangedDate(e);
          }}/>
        </div>
        {/* 언더라인 */}
        <div className='border-b-[1px] border-gray-400 py-1 px-2'></div>
      </div>

      {/* 선택한 내역이 없을경우 */}
      <div className={`${itemState ? 'hidden' : 'inline'}`}>
        <div className='p-3 flex flex-col justify-center items-center'>
          <div className='bg-gray-600 rounded-md p-3 w-full text-center whitespace-normal'>
            <p className='text-2xl'>🧐</p>
            <p>항목 선택시 자세한 정보가 표시됩니다.</p>
          </div>
        </div>
      </div>

      {/* 사이드 메인 메뉴 */}
      <div className={`p-3 flex flex-col gap-2 ${!itemState ? 'hidden' : 'inline'}`}>

        {/* 상태 및 매장 */}
        <div className={`flex gap-3 
          ${itemState === '추가' && 'bg-blue-500 rounded-md p-1 duration-150 animate-pulse'}
          ${itemState === '삭제' && 'bg-red-500 rounded-md p-1 duration-150 animate-pulse'}
          `}>
          <div className='w-full'>
            <p>상태</p>
            <input disabled type='text' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400 text-center' placeholder='상태' value={itemState} />
          </div>
          <div className='w-full'>
            <p>매장</p>
            <input disabled type='text' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400 text-center' placeholder='매장' value={itemStore} />
          </div>
        </div>
                      
        {/* 언더라인 */}
        <div className='border-b-[1px] border-gray-400 py-1'></div>

        {/* 브랜드 */}
        <div className={`
          flex gap-3 
          ${itemState === '수정' && itemBrand !== itemBrand2 && 'bg-blue-500 duration-150 p-1 rounded-md'}
        `}>
          <div className='w-full'>
            <p>{itemState !== '수정' ? '브랜드' : '기존 브랜드'}</p>
            <input disabled type='text' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400 text-center' placeholder='브랜드' value={itemBrand} />
          </div>
          <div className={`w-full ${itemState !== '수정' ? 'hidden' : 'inline'}`}>
            <p>변경 브랜드</p>
            <input disabled type='text' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400 text-center' placeholder='브랜드' value={itemBrand2} />
          </div>
        </div>

        {/* 언더라인 */}
        <div className='border-b-[1px] border-gray-400 py-1'></div>

        {/* 분류 */}
        <div className={`
          flex gap-3 
          ${itemState === '수정' && itemType !== itemType2 && 'bg-blue-500 duration-150 p-1 rounded-md'}
        `}>
          <div className='w-full'>
          <p>{itemState !== '수정' ? '분류' : '기존 분류'}</p>
            <input disabled type='text' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400 text-center' placeholder='분류' value={itemType} />
          </div>
          <div className={`w-full ${itemState !== '수정' ? 'hidden' : 'inline'}`}>
            <p>변경 분류</p>
            <input disabled type='text' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400 text-center' placeholder='분류' value={itemType2} />
          </div>
        </div>

        {/* 언더라인 */}
        <div className='border-b-[1px] border-gray-400 py-1'></div>

        {/* 제품명 */}
        <div className={`
          flex flex-col gap-3 
          ${itemState === '수정' && itemName !== itemName2 && 'bg-blue-500 duration-150 p-1 rounded-md'}
        `}>
          <div className='w-full'>
          <p>{itemState !== '수정' ? '제품명' : '기존 제품명'}</p>
            <input disabled type='text' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400 text-center' placeholder='제품명' value={itemName} />
          </div>
          <div className={`w-full ${itemState !== '수정' ? 'hidden' : 'inline'}`}>
            <p>변경 제품명</p>
            <input disabled type='text' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400 text-center' placeholder='제품명' value={itemName2} />
          </div>
        </div>

        {/* 언더라인 */}
        <div className='border-b-[1px] border-gray-400 py-1'></div>

        {/* 가격 */}
        <div className={`
          flex gap-3 ${itemState === '수정' && itemPrice < itemPrice2 && 'bg-red-500/80 duration-150 p-1 rounded-md'}
          ${itemState === '수정' && itemPrice > itemPrice2 && 'bg-green-600/80 duration-150 p-1 rounded-md'}
        `}>
          <div className='w-full'>
          <p>{itemState !== '수정' ? '가격' : '기존 가격'}</p>
            <input disabled type='text' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400 text-center' placeholder='가격' value={`${NumberConvert(itemPrice)}`} />
          </div>
          <div className={`w-full ${itemState !== '수정' ? 'hidden' : 'inline'}`}>
            <p>변경 가격</p>
            <input disabled type='text' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400 text-center' placeholder='가격' value={`${NumberConvert(itemPrice2)}`} />
          </div>
        </div>

        {/* 언더라인 */}
        <div className='border-b-[1px] border-gray-400 py-1'></div>

        {/* 재고 */}
        <div className={`
          flex gap-3 ${itemState === '수정' && itemCount > itemCount2 && 'bg-red-500/80 duration-150 p-1 rounded-md'}
          ${itemState === '수정' && itemCount < itemCount2 && 'bg-green-600/80 duration-150 p-1 rounded-md'}
        `}>
          <div className='w-full'>
          <p>{itemState !== '수정' ? '재고' : '기존 재고'}</p>
            <input disabled type='text' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400 text-center' placeholder='재고' value={`${itemCount} 개`} />
          </div>
          <div className={`w-full ${itemState !== '수정' ? 'hidden' : 'inline'}`}>
            <p>변경 재고</p>
            <input disabled type='text' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400 text-center' placeholder='재고' value={`${itemCount2} 개`} />
          </div>
        </div>

        {/* 언더라인 */}
        <div className='border-b-[1px] border-gray-400 py-1'></div>

        {/* 아이디, 날짜 */}
        <div className='flex flex-col gap-3'>
          <div className='w-full'>
            <p>아이디</p>
            <input disabled type='text' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400 text-center' placeholder='처리자' value={itemUser} />
          </div>
          <div className='w-full'>
            <p>처리 날짜</p>
            <input disabled type='text' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400 text-center' placeholder='처리 날짜' value={itemDate} />
          </div>
        </div>

      </div>
    </div>
      
    </div>

  </div>

  )
}

export default ItemManagement